<app-impact-modal #openImpact [modalTitle]="app.text.impact.impact">
</app-impact-modal>

<app-modal
  #addNewImpact
  [modalTitle]="app.text.impact.impact"
  [modalType]="'wf-automation'"
  [showButtons]="false"
  >
</app-modal>
<app-modal
  #seeImpactDetails
  [modalTitle]="app.text.impact.impact"
  [modalType]="'wf-automation'"
  [showButtons]="false"
  >
</app-modal>
<app-modal
  #deleteImpactModal
  [modalMessage]="app.text.impact.deleteMessage"
  [modalTitle]="app.text.thread.modalTitle"
  (ok)="
    app.impact.delete(app.impact.currentImpact);
    removeItem(app.impact.currentImpact)
  "
></app-modal>

<app-modal
  #deleteAllImpactsModal
  [modalMessage]="app.text.impact.deleteAllImpacts"
  [modalTitle]="app.text.thread.modalTitle"
  (ok)="app.impacts.deleteAllImpacts()"
></app-modal>

<input
  #fileInput
  type="file"
  accept=".xlsx"
  style="display: none"
  (change)="upload()"
  multiple
  />
<div>
  @if (app.leftNav.selectedBox === 'thread.impacts') {
    <div
      class="controls mx-2 pt-1"
    [ngClass]="{
      'where-used-controls':
        app.customers.hasRM() &&
        app.customers.getSpecialCustomers() === 'usual-configuration'
    }"
      >
      @if (showAddImpactBtn && app.customers.expectCurrent !== 'db') {
        <button
          class="btn btn-sm btn-default-orange"
          (click)="openImpact.open()"
          >
          <i class="fa fa-plus"></i>&nbsp;&nbsp; {{ app.text.app.add }}
        </button>
      }
      @if (showAddImpactBtn && app.customers.expectCurrent === 'db') {
        <button
          class="btn btn-sm btn-default-orange"
          (click)="app.state.impactId = null; addNewImpact.open()"
          >
          <i class="fa fa-plus"></i>&nbsp;&nbsp; {{ app.text.app.add }}
        </button>
      }
      @if (app.permission.impact.canImportImpacts &&
        app.customers.expectCurrent !== 'db' ) {
        <button
          class="btn btn-sm btn-default-orange"
          (click)="fileInput.click()"
          [title]="app.text.import.upload"
          [disabled]="showImportImpactBtn"
          >
          <i class="fa fa-upload"></i>
          &nbsp;&nbsp; {{ app.text.impact.import }}
        </button>
      }
    </div>
  }
  <div class="container-fluid">
    <div class="row">
      @if (manualAddVisibile()) {
        <app-field
          class="col-md-6 col-lg-6 col-xl-6"
          [field]="app.fieldId.impact.omfVehicleName"
          [model]="vehicleNameModel"
          (selected)="app.impact.addImpact(vehicleNameModel)"
          [labelInside]="true"
          [orangeField]="true"
          [showLabel]="false"
        ></app-field>
      }
      <div class="col controls p-0">
        <div class="m-1">
          @if (
            app.customers.expectCurrent === 'db' &&
            app.permission.impact.canImportImpacts
            ) {
            <button
              class="btn btn-sm btn-clean"
              (click)="fileInput.click()"
              [title]="app.text.import.upload"
              >
              <i class="fa fa-upload"></i>&nbsp;
              <span>
                {{ app.text.impact.uploadMultiple }}
              </span>
            </button>
          }
          @if (app.permission.vehicleResponsible.edit) {
            <button
              class="btn btn-sm btn-clean"
              [title]="app.text.vehicleResponsible.edit"
              (click)="app.routing.navigateVehicleResponsibles()"
              >
              {{ app.text.vehicleResponsible.edit }}
            </button>
          }
          @if (app.permission.impact.canDeleteImpacts) {
            <button
              class="btn btn-sm btn-clean"
              (click)="deleteAllImpactsModal.open()"
              >
              {{ app.text.impact.deleteImpacts }}
            </button>
          }
        </div>
      </div>
    </div>
  </div>
  @if (app.customers.expectCurrent === 'db') {
    <div
      class="d-flex flex-row-reverse"
      >
      <ul class="legend-list">
        <li>
          <i class="fad fa-user-check" id="fa-green"></i>&nbsp;
          <span class="lineHeight">{{ app.text.impact.greenBullet }}</span>
        </li>
        <li>
          <i class="fad fa-user-times" id="fa-red"></i>&nbsp;
          <span class="lineHeight">{{ app.text.impact.redBullet }}</span>
        </li>
      </ul>
    </div>
  }
</div>

<!-- ALL clients impacts table design, except DB  -->
@if (
  (app.customers.getRMCustomers() === 'non-rm-client' ||
  app.customers.getSpecialCustomers() === 'special-configuration') &&
  app.customers.expectCurrent !== 'db'
  ) {
  <div
    class="tableFixHead"
    >
    <table class="table table-striped">
      <thead>
        <tr>
          @for (column of app.list.impact.columns; track column) {
            <th class="p-1">
              {{ app.field.getLabel(column) }}
            </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (impact of impacts; track impact; let i = $index) {
          <tr
            (click)="openImpact.open(impact)"
            >
            @for (column of app.list.impact.columns; track column) {
              <td class="pointer p-1">
                @if (column !== 'impact.actions') {
                  <span>
                    {{ impact[column.split(".")[1]] }}
                  </span>
                }
                @if (
                  column === 'impact.actions' &&
                  app.permission.impact.canAddImpactToCase
                  ) {
                  <button
                    class="btn btn-sm"
            (click)="
              $event.stopPropagation();
              app.impact.currentImpact = impact;
              deleteImpactModal.open()
            "
                    >
                    <i class="fa fa-trash text-center"></i>
                  </button>
                }
              </td>
            }
          </tr>
        }
        <tr>
          @if (app.paginator.getPageWithDoc().length === 0) {
            <td
              colspan="99"
              class="text-center"
              >
              {{ app.text.app.noResults }}
            </td>
          }
        </tr>
      </tbody>
    </table>
  </div>
}

<!-- DB impacts table design -->
@if (app.customers.expectCurrent === 'db') {
  <div class="top-line">
    <app-paginator
      [length]="app.impacts.impactIds.length"
      [index]="app.paginator.focus"
      (focus)="app.paginator.focus = $event"
    ></app-paginator>
    <div class="tableFixHead">
      <table class="table table-striped">
        <thead class="text-center">
          <tr class="departmentRow">
            <th></th>
            <th></th>
            <th colspan="2" class="departmentNames">FV</th>
            <th colspan="2" class="departmentNames">Regio</th>
            <th colspan="2" class="departmentNames">Cargo</th>
            <th colspan="2" class="departmentNames">FZI</th>
            <th colspan="2" class="departmentNames">Sonstige</th>
            @if (app.permission.impact.edit) {
              <th></th>
            }
          </tr>
          <tr>
            <th>{{ app.field.getLabel("impact.omfVehicleName") }}</th>
            <th>GF</th>
            <th>BAV</th>
            <th>MaWI</th>
            <th>BAV</th>
            <th>MaWI</th>
            <th>BAV</th>
            <th>MaWI</th>
            <th>BAV</th>
            <th>MaWI</th>
            <th>BAV</th>
            <th>MaWI</th>
            @if (app.permission.impact.edit) {
              <th>
                {{ app.field.getLabel("impact.actions") }}
              </th>
            }
          </tr>
          <tr>
            @for (column of columnsShort; track column) {
              <th class="min-width-120">
                <div>
                  <app-filter-table
                    [column]="column"
                    [columns]="columnsShort"
                    [docType]="'impact'"
                    [cleanDocs]="app.impacts.cleanImpacts"
                    [selectedFilters]="selectedFilters"
                (resultedDocs)="
                  app.filterTable.getFilterResults($event, 'impact')
                "
                    >
                  </app-filter-table>
                </div>
              </th>
            }
          </tr>
        </thead>
        <tbody>
          @for (impact of app.paginator.getPageWithDoc(); track impact; let i = $index) {
            <tr
              (click)="seeImpactDetails.open(); app.state.impactId = impact._id"
              >
              @for (column of columns; track column) {
                <td class="pointer" id="{{ column }}">
                  @if (
                    (column === 'impact.omfVehicleName' ||
                    'impact.omfVehicleFleet') &&
                    impact
                    ) {
                    <span
                      >
                      {{ impact[column.split(".")[1]] }}
                    </span>
                  }
                  @if (
                    column !== 'impact.omfVehicleName' &&
                    column !== 'impact.omfVehicleFleet' &&
                    impact
                    ) {
                    <div
                      class="cell responsiblesCell"
                      >
                      <span>   {{ app.users.getOptionName(impact["responsibles"][column.split(".")[1]] ) }} </span>
                      @if (
                        impact['responsibles'][column.split('.')[1]] !== '' &&
                        app.impact.displayBullet(
                        column.split('.')[1],
                        green,
                        impact['responsibles'],
                        impact['omfVehicleName']
                        )
                        ) {
                        <i
                          class="fad fa-user-check pull-right"
                        ></i>
                      }
                      @if (
                        impact['responsibles'][column.split('.')[1]] !== '' &&
                        app.impact.displayBullet(
                        column.split('.')[1],
                        red,
                        impact['responsibles'],
                        impact['omfVehicleName']
                        )
                        ) {
                        <i
                          class="fad fa-user-times pull-right"
                        ></i>
                      }
                    </div>
                  }
                  @if (column === 'impact.actions' && app.permission.impact.edit) {
                    <span
              (click)="
                $event.stopPropagation();
                app.impact.currentImpact = impact;
                deleteImpactModal.open()
              "
                      >
                      <i class="fa fa-trash"></i>
                    </span>
                  }
                </td>
              }
            </tr>
          }
          <tr>
            @if (app.paginator.getPageWithDoc().length === 0) {
              <td
                colspan="99"
                class="text-center"
                >
                {{ app.text.app.noResults }}
              </td>
            }
          </tr>
        </tbody>
      </table>
    </div>
    @if (app.customers.expectCurrent === 'db') {
      <app-paginator
        [length]="app.impacts.impactIds.length"
        [index]="app.paginator.focus"
        (focus)="app.paginator.focus = $event"
      ></app-paginator>
    }
  </div>
}
@if (
  app.customers.hasRM() &&
  app.customers.getSpecialCustomers() === 'usual-configuration'
  ) {
  <app-where-used-in
  ></app-where-used-in>
}
